// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-menu-item.ui-menu-item--confirm[data-v-510ea11b]{background-color:#eb6b60}.ui-menu-item.ui-menu-item--confirm .ui-menu-item__icon[data-v-510ea11b],.ui-menu-item.ui-menu-item--confirm .ui-menu-item__label[data-v-510ea11b]{color:#fff}.ui-menu-item i.fa[data-v-510ea11b],.ui-menu-item i.fas[data-v-510ea11b],.ui-menu-item i.far[data-v-510ea11b],.ui-menu-item i.fal[data-v-510ea11b]{font-size:22px}\n", ""]);
// Exports
module.exports = exports;
